// src/components/molecules/ActiveFilterCountChip/ActiveFilterCountChip.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Chip, useTheme } from '@mui/material';
import { operationalRadii } from '../../../design-system/tokens';

const ActiveFilterCountChip = ({ count, className = '', sx, ...props }) => {
  const theme = useTheme();

  if (!count) return null;

  return (
    <Chip
      label={`${count} ativo${count !== 1 ? 's' : ''}`}
      color="primary"
      size="small"
      variant="filled"
      className={`active-filter-count-chip ${className}`}
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        borderRadius: `${operationalRadii.control}px`,
        ...sx
      }}
      {...props}
    />
  );
};

ActiveFilterCountChip.propTypes = {
  count: PropTypes.number.isRequired,
  className: PropTypes.string,
  sx: PropTypes.object
};

export default ActiveFilterCountChip;
